import db from "@/plugins/dexie";
import { USER_STORAGE  } from '@/constants/STORAGE'
import apirecebimentoweb from '@/services/api-recebimentoweb';
import moment from "moment-timezone";

function getSessionStorage(key, defaultValue) {
  return sessionStorage.getItem(key) ?? defaultValue;
}

export default async function $_enviaAmostra() {
  const token = JSON.parse(sessionStorage.getItem('auth:token'));
  let amostra = await db.amostra.toArray();
  amostra = amostra.filter(a => !a.amoidnuvem || !a.amodatanuvem);
  const idusuario = await getSessionStorage(USER_STORAGE.useidusuario);
  amostra.forEach((item) => {
          if ((item.amoidnuvem)) {
              console.log('put - ', item);
              const payload = {
                id: item.amoidnuvem,
                amsidusuario: idusuario,
                amsstatus: item.amostatus,
                amsfluxoar: item.amofluxoar,
                amsobservacao: item.amoobservacao,
                amsumidade: item.amoumidade,
                amsumidadecima: item.amoumidadecima,
                amsumidademeio: item.amoumidademeio,
                amsumidadebaixo: item.amoumidadebaixo,
                amsdataamostra: item.amodataamostra,
                amsdatastatus: item.amodatastatus,
              }

              apirecebimentoweb.put(`/amostrasecagem/${item.amoidnuvem}`, payload, {
                  headers: {
                      Authorization: `Bearer ${token.token}`
                  }
              }).then((res) => {
                  const alteracao = (moment.utc(res.data.amsdataalteracao).subtract(3, 'hours').format('YYYY-MM-DDTHH:mm:ss'))
                  db.amostra.update(item.id, {
                      amodataalteracao: alteracao,
                      amodatanuvem: alteracao,
                  });
              });    
          } else {
              console.log('post - ', item);
              const payload = {
                amsidusuario: idusuario,
                amsstatus: item.amostatus,
                amsfluxoar: item.amofluxoar,
                amsobservacao: item.amoobservacao,
                amsumidade: item.amoumidade,
                amsumidadecima: item.amoumidadecima,
                amsumidademeio: item.amoumidademeio,
                amsumidadebaixo: item.amoumidadebaixo,
                amsdataamostra: item.amodataamostra,
                amsdatastatus: item.amodatastatus ? item.amodatastatus : null,
                amsdataoperacao: item.amodataoperacao,
              }

              apirecebimentoweb.post('/amostrasecagem', payload, {
                  headers: {
                      Authorization: `Bearer ${token.token}`
                  }
              }).then((res) => {
                  console.log(res, 'res');
                  const alteracao = (moment.utc(res.data.amsdataalteracao).subtract(3, 'hours').format('YYYY-MM-DDTHH:mm:ss'))
                  db.amostra.update(item.id, {
                      amoidnuvem: res.data.id,
                      amodataalteracao: alteracao,
                      amodatanuvem: alteracao,
                  });
              });
          }
  }); 
}